import moment from 'moment'

export const toDotObject = (input: Record<string, any>, partialObject = {}, path = '') => {
  return Object.entries(input).reduce((acc, row) => {
    let [name, item] = row
    const currentPath = !!path ? `${path}.${name}` : name

    if (moment.isMoment(item)) {
      return {
        ...partialObject,
        ...acc,
        [currentPath]: item.format('YYYY-MM-DD'),
      }
    }

    if (typeof item === 'object' && item !== null) {
      return toDotObject(item, acc, currentPath)
    }

    return {
      ...partialObject,
      ...acc,
      [currentPath]: item,
    }
  }, {})
}
